<template>
  <q-col
    :span="16"
  >
    <router-view />
  </q-col>
</template>

<script>
  export default {
    name: "BlogCardList",

    data() {
      return {};
    },
    methods: {}
  }
</script>

<style scoped>

</style>